import Partnership from '../../assets/images/Partnership.png';
import Price from '../../assets/images/Price.png';
import Quality from '../../assets/images/Quality.png';
import Trends from '../../assets/images/Trends.png';
import './UltronFeatures.css';

const UltronFeatures = () => {
    const features = [
        {
            id: 1,
            title: "Quality",
            discription: "We meticulously select each fabric to meets the highest standards, providing you with durable, comfortable, and aesthetically pleasing materials.",
            image: Quality,
        },
        {
            id: 1,
            title: "Pricing",
            discription: "By leveraging our strong supplier relationships and efficient operations, we offer competitive pricing without compromising on quality.",
            image: Price,
        },
        {
            id: 1,
            title: "Partnerships",
            discription: "Our long-standing relationships with garment manufactures speak to our reliability and commitment to excellence",
            image: Partnership,
        },
        {
            id: 1,
            title: "Trends",
            discription: "We bring you the latest fabrics that reflect current styles and technological advancements in the textile industry",
            image: Trends,
        },
    ]
    return (
        <div className="features">
            <h3 data-aos='fade-down' className='features-tilte'>Why FabInsta?</h3>
            <h2 data-aos='fade-down' className='features-heading'>Uncover the best in style and value</h2>
            <p data-aos='fade-down' className='features-description'>
                Experience unparalleled quality, durability, and style with our fabrics, crafted to elevate your creations.
                Discover a world of possibilities with our diverse range of materials, expertly designed to meet your unique needs. 
                Trust us for fabrics that exceed your expectations.
            </p>
            <div className="feature-cards">
                {
                    features.map((feature,index) => (
                        <div  key={feature.title|| index}  className="feature-card" data-aos='fade-down'>
                            <div>
                                <img src={`${feature.image}?time=${Date.now()}`} alt="Diverse" className='feature-card-image' />
                                <h3 className='feature-card-title'>{feature.title}</h3>
                                <p className='feature-card-description'>{feature.discription}</p>
                            </div>
                            <span className='feature-card-vertical'></span>
                        </div>
                    ))
                }
            </div>
        </div>
    );
};

export default UltronFeatures;
